import React, { FC } from 'react';

import { InfoBlockFullscreenNotification } from '@/shared/components/InfoBlockFullscreenNotification/InfoBlockFullscreenNotification';

import { useYangoOnboardingConfig } from '../../hooks/useYangoOnboardingConfig';
import { TvChannelsInfoBlock } from '../multi-offer-info-blocks/TvChannelsInfoBlock/TvChannelsInfoBlock';
import { BenefitsInfoBlock } from '../multi-offer-info-blocks/BenefitsInfoBlock/BenefitsInfoBlock';
import { HomeFaq } from '../HomeFaq/HomeFaq';

export const InfoBlocks: FC = () => {
    const config = useYangoOnboardingConfig();

    const showInfoBlocks = Boolean(config?.isInfoBlocksSectionEnabled);

    return (
        <>
            {showInfoBlocks && (
                <>
                    <TvChannelsInfoBlock />
                    <BenefitsInfoBlock />

                    <InfoBlockFullscreenNotification />
                </>
            )}
            <HomeFaq />
        </>
    );
};
